/* eslint-disable css-modules/no-unused-class  */
import { useGetAssessmentsResults, useGetUncompletedAssessments } from '@queries/platform/assessments';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from '@redux/slices/informationSlice';
import AssessmentPage from './assessmentPage';
import { AssessmentBannerProps as AssessmentBanner } from './banner/assessmentBanner';
import { OverallAchievementsProps as OverallAchievements } from './overall/overallAchievements';
import { ResultsCardProps as AssessmentsResults } from './resultsCard/resultsCard';

const AssessmentPageContainer: FC = () => {
    const dispatch = useDispatch();
    const [uncompletedAssessments, setUncompletedAssessments] = useState<AssessmentBanner[]>([]);
    const [overallAchievements, setOverallAchievements] = useState<OverallAchievements>();
    const [assessmentsResults, setAssessmentsResults] = useState<AssessmentsResults[]>([]);
    const [isAssessmentResultsLoading, setIsAssessmentResultsLoading] = useState<boolean>(true);

    const { data: uncompletedAssessmentsData, isLoading: isUncompletedAssessmentsLoading } =
        useGetUncompletedAssessments();
    const { data: assessmentResults } = useGetAssessmentsResults();

    useEffect(() => {
        if (!uncompletedAssessmentsData?.assessments) return;

        const uncompletedAssessmentsTmp: AssessmentBanner[] = uncompletedAssessmentsData?.assessments.map(
            (assessment: any) => {
                return {
                    uuid: assessment.uuid,
                    name: assessment.name,
                    url: assessment.url,
                    categories: assessment.categories,
                    fromDate: assessment.start_date,
                    toDate: assessment.end_date,
                    isStarted: assessment.is_started
                };
            }
        );
        setUncompletedAssessments(uncompletedAssessmentsTmp);
    }, [uncompletedAssessmentsData]);

    useEffect(() => {
        if (assessmentResults?.success === false) {
            dispatch(
                showAlert({
                    value: 'Error loading assessments results',
                    status: 'error'
                })
            );
        }

        if (!assessmentResults) return;
        setIsAssessmentResultsLoading(true);
        const assessmentsBreakdown = assessmentResults.assessments_breakdown;
        const assessmentsOverallStats = assessmentResults.overall_statistics;

        if (assessmentsBreakdown) {
            const assessmentResultsTmp = assessmentsBreakdown.map((assessment: any) => {
                return {
                    name: assessment.name,
                    score: assessment.rating,
                    totalQuestions: assessment.total_questions,
                    correctAnswers: assessment.correct_answers,
                    startDate: assessment.start_date,
                    endDate: assessment.end_date,
                    answers: assessment.answers_breakdown.map((assessmentAnswer: any) => {
                        return {
                            category: assessmentAnswer.category,
                            vulnerability: assessmentAnswer.vulnerability,
                            isCorrect: assessmentAnswer.is_correct
                        };
                    })
                };
            });
            setAssessmentsResults(assessmentResultsTmp.reverse());
            setIsAssessmentResultsLoading(false);
        }

        if (assessmentsOverallStats) {
            const assessmentOverallStats: OverallAchievements = {
                assessmentsTakenNumber: assessmentResults.overall_statistics.total_completed_assessments,
                strongCategories: assessmentResults.overall_statistics.categories.strong,
                fairCategories: assessmentResults.overall_statistics.categories.fair,
                poorCategories: assessmentResults.overall_statistics.categories.poor,
                overallRating: assessmentResults.overall_statistics.average_rating
            };
            setOverallAchievements(assessmentOverallStats);
        }
    }, [assessmentResults]);

    return (
        <>
            <AssessmentPage
                newAssessments={uncompletedAssessments}
                overallAchievements={overallAchievements}
                assessmentsResults={assessmentsResults}
                isAssessmentResultsLoading={isAssessmentResultsLoading}
                isUncompletedAssessmentsLoading={isUncompletedAssessmentsLoading}
            />
        </>
    );
};

export default AssessmentPageContainer;
